import { render, staticRenderFns } from "./InsumoManageModal.vue?vue&type=template&id=92a5adca&scoped=true"
import script from "./InsumoManageModal.vue?vue&type=script&lang=js"
export * from "./InsumoManageModal.vue?vue&type=script&lang=js"
import style0 from "./InsumoManageModal.vue?vue&type=style&index=0&id=92a5adca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a5adca",
  null
  
)

export default component.exports